import { Injectable, Optional, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class FreshdeskService {
  constructor(
    private http: HttpClient,
    @Optional()
    @Inject('BASE_URL')
    private BASE_URL: string
  ) {}

  getTickets() {
    return this.http.get<{ count: number; tickets: [] }>(`${this.BASE_URL}api/freshdesk/tickets`);
  }
}
